export default __webpack_public_path__ + "static/media/female-icon.56fcf7f2.svg";